
import { graphqlApolloClient } from "../graphql-apollo-client"
import { ADD_BENEFICIARY_PROFILE_TO_PROJECT_BENEFICIARY }
  from "./graphql/mutations/addBeneficiaryProfileToProjectBeneficiary"

export const addBeneficiaryProfileToProjectBeneficiary =
  async ({ projectBeneficiaryID, beneficiaryProfileID,  status }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: ADD_BENEFICIARY_PROFILE_TO_PROJECT_BENEFICIARY,
      variables: { projectBeneficiaryID, beneficiaryProfileID, status }
    })

    return data?.AddBeneficiaryProfileToProjectBeneficiary
  }